var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',{attrs:{"label":_vm.$t('Restockable Item')},model:{value:(_vm.is_restockable),callback:function ($$v) {_vm.is_restockable=$$v},expression:"is_restockable"}})}
var staticRenderFns = []

export { render, staticRenderFns }